import { render, staticRenderFns } from "./Objetive.vue?vue&type=template&id=3c7be91e&scoped=true&"
import script from "./Objetive.vue?vue&type=script&lang=js&"
export * from "./Objetive.vue?vue&type=script&lang=js&"
import style0 from "./Objetive.vue?vue&type=style&index=0&id=3c7be91e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7be91e",
  null
  
)

export default component.exports